/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @version 1.1.0
 * @since 1.1.0
 */
import { FC, Fragment } from 'react';

import { TextContainerStyled } from './styled/TextBlockStyled';

interface IExtensibleTextBlock {
    inserts: any[];
    text: string;
}

const ExtensibleTextBlock: FC<IExtensibleTextBlock> = props => {
    const expandedText = props.text.split('${}');
    return (
        <TextContainerStyled>
            {
                expandedText.map((text: string, index: number) => (
                    <Fragment key={index}>
                        {text}
                        {props.inserts[index] ?? null}
                    </Fragment>
                ))
            }
        </TextContainerStyled>
    );
};

export default ExtensibleTextBlock;
